/** Greška s HTTP statusom — rute je pretvore u odgovor s tim statusom i porukom. */
export function httpError(message: string, status: number): Error {
  const e = new Error(message);
  (e as any).status = status;
  return e;
}
